import history from '../config/history';
// Local Deps:
import { homeRoute } from '../config/navigation/routes';

export function forwardTo(location) {
  history.push(location);
}

export function forwardToHome() {
  forwardTo(homeRoute, history);
}
export function checkLocation() {
  if (history.location.pathname === '/register') {
    return true;
  }
  if (history.location.pathname.includes('/history/search')) {
    return true;
  }
  if (history.location.pathname === '/suppliers') {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/browserHistoryUtils.js